import axios, { type AxiosRequestConfig } from 'axios';
import { config, createHeaders } from '.';
import { LoadLocationByCompanyData } from '../models/Location';

export const loadLocationsByCompanyId = async (
	companyId: number,
	accessToken: string
) => {
	const localConfig: AxiosRequestConfig = {
		...config,
		url: `company/${companyId}/locations`,
		method: 'get',
		headers: createHeaders({ accessToken })
	};

	return axios.request<LoadLocationByCompanyData>(localConfig);
};
